import { useCreator } from '@hooks/useCreator';

const GetUserTableItemContainer = ({ userID, render }) => {
  const { firstName, lastName } = useCreator(userID);

  return render({ firstName, lastName });
};

export default GetUserTableItemContainer;
